(function () {
  'use strict';

  if (window.AxiomProductPopupBound) return;
  window.AxiomProductPopupBound = true;

  function api() {
    return window.Axiom || {};
  }

  function rootFrom(target) {
    return target && target.closest ? target.closest('[data-product-popup]') : null;
  }

  function parts(root) {
    if (!root) return null;
    return {
      root: root,
      trigger: root._popupTrigger || root.querySelector('[data-product-popup-open]'),
      overlay: document.getElementById('site-overlay'),
      panel: root._popupPanel || root.querySelector('.product-popup__panel')
    };
  }

  function rememberHome(panel, root) {
    if (!panel) return;
    root._popupPanel = panel;
    if (panel._popupHome) return;
    panel._popupHome = {
      parent: panel.parentNode,
      next: panel.nextSibling,
      root: root
    };
  }

  function movePanelToBody(panel) {
    if (!panel || panel.parentNode === document.body) return;
    document.body.appendChild(panel);
  }

  function restorePanel(panel) {
    var home = panel && panel._popupHome;
    if (!home || !home.parent) return;
    // Its block was re-rendered (theme editor) while the panel sat in the body: drop it.
    if (!home.parent.isConnected) {
      panel.remove();
      return;
    }
    if (home.next && home.next.parentNode === home.parent) {
      home.parent.insertBefore(panel, home.next);
    } else {
      home.parent.appendChild(panel);
    }
  }

  function isOpen(panel) {
    return Boolean(panel && panel.classList.contains('is-open'));
  }

  function setExpanded(trigger, expanded) {
    if (trigger) trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
  }

  // options.preview: opened or closed by the theme editor (no focus moved, no scroll lock).
  function openPopup(root, options) {
    var refs = parts(root);
    if (!refs || !refs.panel) return;
    var preview = Boolean(options && options.preview);
    var overlay = refs.overlay;
    rememberHome(refs.panel, root);
    movePanelToBody(refs.panel);
    refs.panel.hidden = false;
    void refs.panel.offsetWidth; // commit display before the open transition starts
    if (refs.panel.getAttribute('inert') !== null) refs.panel.removeAttribute('inert');
    // Opened over Quick view (or another layer) the backdrop is already shown
    // and stays theirs: closing the popup leaves it on.
    refs.panel._popupSharesOverlay = Boolean(overlay && overlay.classList.contains('is-open'));
    if (overlay) overlay.classList.add('overlay--product-popup-active');

    // Escape (global.js layer stack) closes the popup only while it is on top.
    var onEscape = function () { closePopup(root); };
    var theme = api();
    if (root.dataset.productPopupStyle === 'drawer' && typeof theme.openDrawer === 'function') {
      theme.openDrawer(refs.panel, overlay, {
        autofocus: preview ? false : undefined,
        lockScroll: !preview,
        returnFocus: preview ? null : refs.trigger,
        trapFocus: true,
        onEscape: onEscape
      });
    } else if (typeof theme.openModal === 'function') {
      theme.openModal(refs.panel, overlay, preview
        ? { onEscape: onEscape, autofocus: false, lockScroll: false }
        : { onEscape: onEscape });
    } else {
      refs.panel.classList.add('is-open');
      refs.panel.setAttribute('aria-hidden', 'false');
      if (overlay) overlay.classList.add('is-open');
    }
    setExpanded(refs.trigger, true);
  }

  function closePopup(root, options) {
    var refs = parts(root);
    if (!refs || !refs.panel) return;
    var overlay = refs.overlay;
    var panel = refs.panel;
    var ownOverlay = panel._popupSharesOverlay ? null : overlay;
    var theme = api();
    if (root.dataset.productPopupStyle === 'drawer' && typeof theme.closeDrawer === 'function') {
      theme.closeDrawer(panel, ownOverlay);
    } else if (typeof theme.closeModal === 'function') {
      theme.closeModal(panel, ownOverlay);
    } else {
      panel.classList.remove('is-open');
      panel.setAttribute('aria-hidden', 'true');
      if (ownOverlay) ownOverlay.classList.remove('is-open');
    }
    panel.setAttribute('inert', '');
    if (overlay) overlay.classList.remove('overlay--product-popup-active');
    setExpanded(refs.trigger, false);
    if (refs.trigger && refs.trigger.isConnected && !(options && options.preview)) refs.trigger.focus({ preventScroll: true });
    window.setTimeout(function () {
      if (isOpen(panel)) return;
      panel.hidden = true;
      restorePanel(panel);
    }, 480);
  }

  document.addEventListener('click', function (event) {
    if (event.target && event.target.id === 'site-overlay' && event.target.classList.contains('overlay--product-popup-active')) {
      var openPanel = document.querySelector('.product-popup__panel.is-open');
      var homeRoot = openPanel && openPanel._popupHome && openPanel._popupHome.root;
      if (homeRoot) closePopup(homeRoot);
      return;
    }

    var closer = event.target.closest && event.target.closest('[data-product-popup-close]');
    if (closer) {
      var closeRoot = rootFrom(closer) || (closer.closest && closer.closest('.product-popup__panel') && closer.closest('.product-popup__panel')._popupHome && closer.closest('.product-popup__panel')._popupHome.root);
      if (closeRoot) closePopup(closeRoot);
      return;
    }

    var opener = event.target.closest && event.target.closest('[data-product-popup-open]');
    if (!opener) return;
    var root = rootFrom(opener);
    if (!root) {
      var panelId = opener.getAttribute('aria-controls');
      var targetPanel = panelId && document.getElementById(panelId);
      root = rootFrom(targetPanel) || (targetPanel && targetPanel._popupHome && targetPanel._popupHome.root);
      if (root) root._popupTrigger = opener;
    }
    var refs = parts(root);
    if (!refs) return;
    if (isOpen(refs.panel)) closePopup(root);
    else openPopup(root);
  });

  // Theme editor: a selected Pop-up block opens its pop-up; selecting anything else closes it
  // (theme-editor.js).
  var editorRoot = null;

  if (window.Axiom && window.Axiom.editor) {
    window.Axiom.editor.register('product-popup', {
      block: '[data-product-popup]',
      open: function (root) {
        if (editorRoot && editorRoot !== root) closeEditorPopup();
        editorRoot = root;
        var refs = parts(root);
        if (refs && refs.panel && !isOpen(refs.panel)) openPopup(root, { preview: true });
      },
      close: closeEditorPopup
    });
  }

  function closeEditorPopup() {
    var refs = parts(editorRoot);
    if (refs && refs.panel && isOpen(refs.panel)) closePopup(editorRoot, { preview: true });
    editorRoot = null;
  }
})();
